import classnames from 'classnames';
import {
  ErrorPageHeader as V3ErrorPageHeader,
  ErrorPageHeaderProps,
} from '@stadionhq-v3/base-ui';
import styles from './errorPageHeader.module.scss';

export const ErrorPageHeader = ({ ...props }: ErrorPageHeaderProps) => {
  const classes = classnames([
    styles.errorPageHeaderTokens,
    styles.errorPageHeader,
    props.error === '500 Error' ? styles.fullscreen : null,
  ]);

  return <V3ErrorPageHeader classNames={[classes]} {...props} />;
};
